module.exports = __webpack_public_path__ + "static/media/10.45c5349b.png";


//////////////////
// WEBPACK FOOTER
// ./src/workoutPreview/img/10.png
// module id = 2117
// module chunks = 0